import { formatRoundS, formatRoundSTrim } from './mathUtilities';

/**
 * Smart format number with decimal precision, removing unnecessary trailing zeros
 * @param value - The number to format
 * @param maxDecimals - Maximum number of decimal places
 * @param forceDecimals - Whether to force display of decimal places (uses .toFixed() behavior)
 * @returns Formatted number string
 */
export function smartFormatDecimal(value: number, maxDecimals: number, forceDecimals: boolean = false): string {
    if (forceDecimals) {
        // Use the existing .toFixed() behavior for cases that need exact decimal places
        return value.toFixed(maxDecimals);
    } else {
        // Use formatRoundS for precise rounding, then remove trailing zeros
        return formatRoundSTrim(value, maxDecimals) ?? '0';
    }
}
